angular
    .module('webmailWrapper')
    .service('util', function() {
        this.getValueAtPathOfObject = (obj, path, defaultValue) => {
            const travel = (regexp) =>
                path.split(regexp)
                    .filter(Boolean)
                    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
            const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);

            return result === undefined || result === obj ? defaultValue : result;
        };
    })


